import {
  QueryConstraint,
  QuerySnapshot,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore'
import { firebaseDb } from './init'
import { IBookmark, IBookmarkRaw, IGenericError } from '../types'

const bookmarksCollectionRef = collection(firebaseDb, 'bookmarks')

const bookmarksDocRef = (id: string) => doc(firebaseDb, 'bookmarks', id)

export async function getBookmarksByUserId(
  userId: string,
  queryConstraints: QueryConstraint[] = [],
): Promise<IBookmark[]> {
  try {
    const docsRef = collection(firebaseDb, 'bookmarks', userId, 'items')
    const q = query(docsRef, ...queryConstraints)
    const querySnapshot = (await getDocs(
      q,
    )) as unknown as QuerySnapshot<IBookmarkRaw>

    let documents: IBookmark[] = []

    querySnapshot.forEach((snapshot) => {
      documents.push({
        id: snapshot.id,
        ...snapshot.data(),
      })
    })

    return documents
  } catch (error: unknown) {
    console.error(
      `error while tying to get lessons bookmarks, userId: ${userId}:>> `,
      (error as IGenericError)?.message || error,
    )

    throw new Error(
      (error as IGenericError)?.message ||
        `Unexpected error while trying to get lessons bookmarks`,
    )
  }
}

export async function createBookmark(
  userId: string,
  bookmark: Omit<IBookmark, 'createdAt'>,
): Promise<string> {
  try {
    const parentDocRef = doc(firebaseDb, 'bookmarks', userId)
    const subCollectionRef = collection(parentDocRef, 'items')
    const newDocRef = doc(subCollectionRef, bookmark.id)

    await setDoc(newDocRef, {
      ...bookmark,
      createdAt: serverTimestamp(),
    })

    return bookmark.id
  } catch (error: unknown) {
    console.error(
      `error while tying to create lesson bookmark, userId: ${userId}, lessonId: ${bookmark.id}:>> `,
      (error as IGenericError)?.message || error,
    )

    throw new Error(
      (error as IGenericError)?.message ||
        `Unexpected error while trying to create lesson bookmark`,
    )
  }
}

export async function deleteBookmark(
  userId: string,
  lessonId: string,
): Promise<void> {
  try {
    const docRef = doc(firebaseDb, 'bookmarks', userId, 'items', lessonId)
    await deleteDoc(docRef)
  } catch (error: unknown) {
    console.error(
      `error while tying to delete lesson bookmark, userId: ${userId}, lessonId: ${lessonId} :>> `,
      (error as IGenericError)?.message || error,
    )

    throw new Error(
      (error as IGenericError)?.message ||
        `Unexpected error while trying to delete lesson bookmark`,
    )
  }
}
